<template>
  <v-divider class="my-4" />

  <v-row align="center" class="mb-4">
    <v-col>
      <h3>Inventaire</h3>
    </v-col>
    <v-col cols="auto">
      <AddInventoryDialog :vehicle-id="vehicleId" @added="items = [...items, $event]" />
    </v-col>
  </v-row>

  <draggable v-model="items" item-key="sparepartId" handle=".drag-handle">
    <template #item="{ element }">
      <v-card class="mb-3 pa-4" elevation="2">
        <v-row no-gutters align="start">
          <v-col cols="auto" class="pt-1 pr-2">
            <v-icon class="drag-handle" size="small"> mdi-drag </v-icon>
          </v-col>

          <v-col>
            <div class="text-subtitle-1 font-weight-bold">
              {{ element.sparepartName }}
            </div>

            <div class="text-body-2 text-medium-emphasis mb-3">
              {{ element.sparepartFrenchName }}
            </div>

            <v-row density="compact" align="center">
              <v-col cols="4">
                <v-text-field
                  label="Quantité"
                  type="number"
                  density="compact"
                  hide-details
                  v-model.number="element.quantity"
                  disabled
                />
              </v-col>

              <v-col cols="4">
                <v-text-field
                  label="+ / -"
                  type="number"
                  density="compact"
                  hide-details
                  v-model.number="element.delta"
                />
              </v-col>

              <v-col cols="auto" class="pt-2">
                <v-btn
                  icon="mdi-check"
                  size="small"
                  variant="tonal"
                  @click="updateQuantity(element)"
                />
              </v-col>

              <v-col cols="auto" class="pt-2">
                <v-btn
                  icon="mdi-delete"
                  size="small"
                  variant="tonal"
                  color="error"
                  @click="removeItem(element)"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </draggable>
</template>

<script setup>
import { computed } from "vue";
import draggable from "vuedraggable";
import AddInventoryDialog from "./AddInventoryDialog.vue";
import { deleteInventoryItem, postInventoryItem } from "@/utils/vehicle-api";

const props = defineProps({
  vehicleId: Number,
  modelValue: Array,
});

const emit = defineEmits(["update:modelValue"]);

const items = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});

const removeItem = async (item) => {
  try {
    await deleteInventoryItem(props.vehicleId, item.sparepartId);
    items.value = items.value.filter((i) => i !== item);
  } catch (error) {
    // Ignore
  }
};

const updateQuantity = async (item) => {
  try {
    await postInventoryItem(props.vehicleId, {
      sparepartId: item.sparepartId,
      quantity: item.delta,
    });

    item.quantity += item.delta;
    item.delta = 0;
  } catch (error) {
    // Ignore
  }
};
</script>
